@if (!onSuccess) {
  <div class="onboarding-form">
    <h1>Reset password</h1>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()"
        novalidate>
        <bo-non-field-errors />
        @if (showThrottleWarning()) {
          <div
            role="alert"
            class="alert alert-danger">
            Reset password request was sent already. <br />
            Please try again after {{ timeoutSeconds() }} seconds.
          </div>
        }
        <app-form-field
          boFieldPath="email"
          [label]="'Email address'"
          [placeholder]="'Enter your email address'"></app-form-field>
        <div class="row">
          <div class="col-auto">
            <a
              id="forgotPasswordBackBtn"
              class="btn btn-outline-dark"
              routerLink="../">
              Back
            </a>
          </div>
          <div class="col-auto">
            <app-submit
              btnID="forgotPasswordSubmitBtn"
              [busy]="busy"
              [disabled]="form.invalid || showThrottleWarning()"
              label="Continue"></app-submit>
          </div>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </div>
}

@if (onSuccess) {
  <div class="onboarding-form">
    <h1>Check your email</h1>
    <p class="text-muted">Password reset steps have been shared in the mail.</p>
    <div class="h4 mb-4">{{ emailSentText }}</div>
    <app-resend-btn
      btnID="forgotPasswordResendBtn"
      label="Resend email"
      (click)="emailResend()"
      (keydown)="emailResend()"
      [resend$]="resend$"></app-resend-btn>
  </div>
}
<app-router-switch-btn
  id="forgotPasswordToLoginBtn"
  title="Login"
  urlLink="/login"></app-router-switch-btn>
